import $ = require("jquery");
import ko = require("knockout");
import moment = require("moment");
import Controls = require("./Controls")
import Service = require("./Service");
import Logger = require("./Logger");

import usernameLookup = require("./UsernameLookupService");

import datePickerController = require("../../../lib/datepicker/datepicker");
require("../../../lib/bootstrap-markdown/bootstrap-markdown");
require("jquery.tablednd_0_5");
import kv = require("knockout.validation");
import ClipboardJS = require("clipboard");

export enum DragAndDropMoveType {
    MoveUp,
    MoveDown
}

export class BindingHandlerRegistration {
    static register() {
        //console.log("registring binding handlers");
        ko.bindingHandlers.bootstrapAccordion = {
            init: (elem, value, allBindings) => {
                var options = ko.utils.unwrapObservable(value()),
                    handleClass = ko.utils.unwrapObservable(options.handleSelector) || '[data-toggle]',
                    contentClass = ko.utils.unwrapObservable(options.collapsableSelector) || '.collapse',
                    iconClass = ko.utils.unwrapObservable(options.collapsableIconSelector) || '.panel-collapse',
                    openItem = ko.utils.unwrapObservable(options.openItem) || false,
                    itemClass = '.' + (ko.utils.unwrapObservable(options.item) || 'accordion-group'),
                    items = $(elem).find(contentClass),
                    useAccordion = ko.utils.unwrapObservable(options.openItem) || false,
                    toggle = ko.utils.unwrapObservable(options.toggle) || false;

                var collapseOptions: any = { toggle: toggle };

                if (useAccordion) {
                    collapseOptions.parent = elem;
                }
                //Set initial aria-expanded state
                items.parent().find(".panel-heading button.expander").attr("aria-expanded", "false");

                items.collapse(collapseOptions);


                if (useAccordion && openItem > -1) items.eq(openItem).collapse('show');

                // if the array is dynamic, the collapse should be re-initiated to work properly
                var list = allBindings.get('foreach');
                if (ko.isObservable(list)) {
                    list.subscribe(() => {
                        $(elem).find(contentClass).collapse(collapseOptions);
                    });
                }

                //<span class="expansion-panel-icon"><i aria-hidden="true" class="material-icons"></i><span class="collapsed-hide sr-only">collapse details</span><span class="collapsed-show sr-only">view details</span></span>

                $(elem).on("click", handleClass, e => {
                    $(e.currentTarget).closest(itemClass).find(contentClass).collapse('toggle');
                });
                $(elem).on("shown.bs.collapse", contentClass, e => {
                    var cTarget = $(e.currentTarget);
                    if (cTarget.is(":visible")) {
                        cTarget.parent().find(iconClass).find("i").text("keyboard_arrow_down");

                    }
                    cTarget.parent().find(".panel-heading button.expander").first().attr("aria-expanded", "true");
                });
                $(elem).on("hidden.bs.collapse", contentClass, e => {
                    var cTarget = $(e.currentTarget);
                    if (!cTarget.is(":visible")) {
                        cTarget.parent().find(iconClass).find("i").text("keyboard_arrow_up");

                    }
                    cTarget.parent().find(".panel-heading button.expander").first().attr("aria-expanded", "false");
                });
            }
        };

        // console.log("registering executeOnEnter...")
        ko.bindingHandlers.executeOnEnter = {
            init: (element, valueAccessor) => {
                "use strict";
                // console.log("init executeonenter");
                var methodToExecute = valueAccessor();
                jQuery(element).keydown(event => {
                    if (event.which === 13) {
                        methodToExecute(event);
                        return false;
                    }
                    return true;
                });
            }
        };
        // console.log("executeOnEnter registered");
        function toLocaleStringSupportsLocales() {
            var number = 0;
            try {
                number.toLocaleString('i');
            } catch (e) {
                return e.name === 'RangeError';
            }
            return false;
        }

        var supportsLocales = toLocaleStringSupportsLocales();
        ko.bindingHandlers.numericText = {
            update: (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) => {
                var formattedValue;
                var value = ko.utils.unwrapObservable(valueAccessor());
                var precision = ko.utils.unwrapObservable(allBindingsAccessor().precision) || ko.bindingHandlers.numericText.defaultPrecision;
                formattedValue = "-";
                if (value !== null && value !== undefined) {
                    formattedValue = value.toFixed(precision);
                }

                ko.bindingHandlers.text.update(element, () => formattedValue, allBindingsAccessor, viewModel, bindingContext);
            },
            defaultPrecision: 2
        };
        ko.bindingHandlers.currencyText = {
            update: (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) => {
                var formattedValue;
                var value = ko.utils.unwrapObservable(valueAccessor());
                var precision = ko.utils.unwrapObservable(allBindingsAccessor().precision) || ko.bindingHandlers.currencyText.defaultPrecision;
                formattedValue = "-";
                if (value !== null && value !== undefined) {
                    if (supportsLocales) {
                        try {
                            formattedValue = parseFloat(value.toFixed(precision)).toLocaleString('en', { style: 'currency', currency: 'USD' });

                        } catch (e) {
                            formattedValue = e.name;
                        }
                    } else {
                        formattedValue = "$" + value.toFixed(precision);

                    }
                }

                ko.bindingHandlers.text.update(element, () => formattedValue, allBindingsAccessor, viewModel, bindingContext);
            },
            defaultPrecision: 2
        };

        ko.bindingHandlers.textTransition = {
            init: (element) => {
                $(element).data("initial", true);
                return { "controlsDescendantBindings": true };
            },
            update: (element, valueAccessor, allBindings) => {
                var duration = allBindings.get("delay") || 200;
                var cached = ko.unwrap(valueAccessor());

                if ($(element).data("initial")) {
                    $(element).removeData("initial");
                    ko.utils.setTextContent(element, cached);
                    return;
                }

                $(element).fadeOut(duration, () => {
                    ko.utils.setTextContent(element, cached);
                    $(element).fadeIn(duration);
                });
            }
        };
        ko.bindingHandlers.markdownEditor = {
            init: (element, valueAccessor, allBindingsAccessor) => {
                var options = <BootstrapMarkdownOptions>{};
                var enableSampleMerge = ko.utils.unwrapObservable(allBindingsAccessor().enableSampleMerge);
                console.log(`enableSampleMerge on ${element.id}: ${enableSampleMerge}`);
                if (enableSampleMerge) {
                    options.enableSampleMerge = true;
                }
                var sampleMergeUrl = ko.utils.unwrapObservable(allBindingsAccessor().sampleMergeUrl);
                if (sampleMergeUrl) {
                    options.sampleMergeUrl = sampleMergeUrl;
                }
                var sampleMergeAjaxOptions = ko.utils.unwrapObservable(allBindingsAccessor().sampleMergeAjaxOptions);
                if (sampleMergeAjaxOptions) {
                    options.sampleMergeAjaxOptions = sampleMergeAjaxOptions;
                }

                options.onChange = (e) => {
                    var observable = valueAccessor();
                    observable(e.getContent());
                };

                $(element).markdown(options);
            },
            update: (element, valueAccessor) => {
                //console.log("update");
                var value = ko.utils.unwrapObservable(valueAccessor());

                var e = <BootstrapMarkdown>$(element).data("markdown");
                e.setContent(value);
            }
        }
        // date picker widget binding handler. Used with value binding handler
        // Will look for a "defaultTime" binding that contains the default time to set in 24-hour time in the format of 'HH:MM' e.g.  defaultTime: '17:00'
        // If defaultTime is not present the time for dates will be set to the midnight
        ko.bindingHandlers.datepicker = {
            init: (element, valueAccessor, allBindingsAccessor) => {
                var $el = $(element);
                if (($el.attr("type") === "date" && $el.prop("type") === "date") || ($el.attr("type") === "datetime-local" && $el.prop("type") === "datetime-local")) {
                    // date picker not needed when html5 dates are supported.
                    //console.log(`date picker not needed when html5 dates are supported.  Value is ${ko.utils.unwrapObservable(valueAccessor())}`);
                    //console.dir(element);
                    return;
                }
                var init = {};
                var calendarInputId = element.id + "-calendar";
                init[calendarInputId] = "%m/%d/%Y";

                if (!$el.parent("div.input-prepend").length) {
                    $el.wrap("<div class='input-prepend input-group'></div>");
                }

                $(element).parent().prepend("<input type='hidden' id='" + calendarInputId + "'>");

                var label = allBindingsAccessor.get("calendarLabel") || "";

                var opts: IDatePickerControllerOptions = {
                    formElements: init,
                    noFadeEffect: false,
                    labelText: label,
                    callbackFunctions: {
                        datereturned: [(params: IDatePickerCallbackFunctionParams) => {
                            var observable = valueAccessor();
                            var defaultTimeValue = allBindingsAccessor.get('defaultTime');
                            var defaultHourMin = new Array(0);
                            if (defaultTimeValue) {
                                defaultHourMin = defaultTimeValue.split(":");
                            }
                            if (defaultTimeValue && defaultHourMin.length === 2) {
                                console.log("Default time for control set to: " + defaultTimeValue);
                                observable(moment(params.date).hour(parseInt(defaultHourMin[0])).minute(defaultHourMin[1]));
                            } else {
                                observable(moment(params.date).startOf("day"));
                            }
                        }]
                    }
                };

                datePickerController.createDatePicker(opts);

                //handle disposal (if KO removes by the template binding)
                ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                    datePickerController.destroyDatePicker(calendarInputId);
                    $("#" + calendarInputId).remove();
                });
            },
            update: (element, valueAccessor) => {
                var $el = $(element);
                if ($el.attr("type") === "date" && $el.prop("type") === "date") {
                    // date picker not needed when html5 dates are supported.
                    return;
                }
                //var $el = $(element);
                //if ($el.attr("type") === "date" && $el.prop("type") === "date") {
                //    ko.bindingHandlers.value.update(element, valueAccessor);
                //    return;
                //}
                var value = ko.utils.unwrapObservable(valueAccessor());
                var m = Service.parseMoment(value);

                if (!m || !m.isValid()) {
                    m = moment();
                }
                $("#" + element.id + "-calendar").val(m.format("YYYYMMDD"));
                datePickerController.setDateFromInput(element.id + "-calendar");
            }
        };


        // rolls up date & time extender with value handler and date picker widget handler
        ko.bindingHandlers.datetimepicker = {
            init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {

                var dateType = "datetime";
                var $el = $(element);
                var underlyingObservable = valueAccessor();

                if ($el.attr("type") === "datetime-local" && $el.prop("type") === "datetime-local") {
                    dateType = "isodatetime";

                    if (element.validity !== undefined && element.validity.badInput !== undefined && $el.attr("required") === undefined) {
                        if (!kv.utils.isValidatable(underlyingObservable))
                            underlyingObservable.extend({ validatable: true });

                        if (underlyingObservable.setError !== undefined) {
                            let fg = $el.closest(".form-group");
                            if (fg.length)
                                ko.applyBindingsToNode(fg[0], { validationElement: underlyingObservable });

                            $el.on("blur.datepicker", event => {
                                var target = <any>event.target;

                                if (target && target.validity) {
                                    if (!target.validity.badInput) {
                                        underlyingObservable.clearError();
                                        underlyingObservable.notifySubscribers();
                                    } else {
                                        underlyingObservable.setError("Please enter both a date and time.");
                                    }
                                    underlyingObservable.isModified(true);
                                }
                            });
                        }
                    }
                }

                //console.log("extending underlying observable for datetime of " + dateType);
                //console.dir(ko.extenders);
                var interceptor = underlyingObservable.extend({ datetime: dateType });
                ko.bindingHandlers.value.init(element, () => interceptor, allBindingsAccessor, viewModel, bindingContext);
                ko.bindingHandlers.datepicker.init(element, () => interceptor, allBindingsAccessor, viewModel, bindingContext);

                if (ko.bindingHandlers['validationCore'] && kv.utils.isValidatable(underlyingObservable))
                    ko.bindingHandlers['validationCore'].init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);

                ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                    if (typeof interceptor.dispose === "function") {
                        interceptor.dispose();
                    }
                    $el.off("blur.datepicker");
                });
            },
            update: ko.bindingHandlers.datepicker.update
        };

        // rolls up date only extender with value handler and date picker widget handler
        ko.bindingHandlers.dateonlypicker = {
            init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var dateType = "date";
                var $el = $(element);
                if ($el.attr("type") === "date" && $el.prop("type") === "date") {
                    dateType = "isodate";
                }
                var underlyingObservable = valueAccessor();

                var interceptor = underlyingObservable.extend({ datetime: dateType });
                ko.bindingHandlers.value.init(element, () => interceptor, allBindingsAccessor, viewModel, bindingContext);
                ko.bindingHandlers.datepicker.init(element, () => interceptor, allBindingsAccessor, viewModel, bindingContext);

                if (ko.bindingHandlers['validationCore'] && kv.utils.isValidatable(underlyingObservable))
                    ko.bindingHandlers['validationCore'].init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);

                ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                    interceptor.dispose();
                });
            },
            update: ko.bindingHandlers.datepicker.update
        };

        // rolls up time only extender with value handler
        ko.bindingHandlers.timepicker = {
            init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var dateType = "time";
                var $el = $(element);
                if ($el.attr("type") === "time" && $el.prop("type") === "time") {
                    dateType = "isotime";
                }
                var underlyingObservable = valueAccessor();

                var interceptor = underlyingObservable.extend({ datetime: dateType });

                ko.bindingHandlers.value.init(element, () => interceptor, allBindingsAccessor, viewModel, bindingContext);

                if (ko.bindingHandlers['validationCore'] && kv.utils.isValidatable(underlyingObservable))
                    ko.bindingHandlers['validationCore'].init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);

                ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                    interceptor.dispose();
                });
            },
            update: ko.bindingHandlers.value.update
        };

        ko.bindingHandlers.numericTextInput = {
            init: (element, valueAccessor) => {
                $(element).on("input", function (e) {
                    if (this.valueAsNumber)
                        return true;
                });

                ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                    $(element).off("input");
                });
            },
            update: (element, valueAccessor) => {

            }
        };

        ko.bindingHandlers.checkedRadioToBool = {
            init(element, valueAccessor, allBindingsAccessor) {
                var observable = valueAccessor(),
                    interceptor = ko.pureComputed({
                        read() {
                            var obs = observable();
                            if (obs === undefined || obs === null)
                                return null;
                            return obs.toString();
                        },
                        write(newValue) {
                            observable(newValue === "true");
                        },
                        owner: this
                    });
                ko.applyBindingsToNode(element, { checked: interceptor });
            }
        };

        ko.bindingHandlers.validationUpdate = {
            update(element, valueAccessor) {
                var value = ko.unwrap(valueAccessor());
                $(element).valid();
            }
        };

        ko.bindingHandlers.sortableTable = {
            init: (element, valueAccessor) => {

                var list = valueAccessor();
                var table = $(element);
                table.addClass("multiform");
                var l = (message) => {
                    Logger.log(message);
                };

                var updateTableBehaviors = () => {
                    table.tableDnDUpdate();
                    Controls.multiform.refreshMultiformBehavior(table);
                };
                var reorderComplete = ((choice, moveType) => {
                    var e = jQuery.Event("reordercomplete");
                    table.trigger(e, [choice, moveType]);
                });

                var moveRowUp = (elem) => {
                    l("---moveRowUp called");
                    var tr = $(elem).closest("tr");
                    var tbl = tr.closest("table")[0];
                    var row = tr[0];
                    var choice = ko.dataFor(row);
                    var position = ko.utils.arrayIndexOf((<any>tbl).tBodies[0].rows, row);
                    var newPosition = position - 1;
                    l("trying to move row from position " + position + " to position " + newPosition);
                    if (newPosition >= 0) {
                        list.remove(choice);
                        list.splice(newPosition, 0, choice);
                        updateTableBehaviors();
                        reorderComplete(choice, DragAndDropMoveType.MoveUp);
                        return newPosition;
                    }
                    return position;
                };
                var moveRowDown = (elem) => {
                    l("---moveRowDown called");
                    var tr = $(elem).closest("tr");
                    var tbl = tr.closest("table")[0];
                    var row = tr[0];
                    var totalRows = (<any>tbl).tBodies[0].rows.length;
                    var choice = ko.dataFor(row);
                    var position = ko.utils.arrayIndexOf((<any>tbl).tBodies[0].rows, row);
                    var newPosition = position + 1;
                    l("trying to move row from position " + position + " to position " + newPosition + " (with " + totalRows + " total rows)");
                    if (newPosition < totalRows) {
                        list.remove(choice);
                        list.splice(newPosition, 0, choice);
                        updateTableBehaviors();
                        reorderComplete(choice, DragAndDropMoveType.MoveDown);
                        return newPosition;
                    }
                    return position;
                };

                table.tableDnD({
                    onDrop: (tbl, row) => {
                        var choice = ko.dataFor(row);
                        var oldPosition = ko.utils.arrayIndexOf(ko.unwrap(list), choice);
                        var newPosition = ko.utils.arrayIndexOf(tbl.tBodies[0].rows, row);
                        if (oldPosition !== newPosition) {
                            l("moving from position " + oldPosition + " to position " + newPosition);
                            list.remove(choice);
                            list.splice(newPosition, 0, choice);
                            updateTableBehaviors();
                            reorderComplete(choice, newPosition < oldPosition ? DragAndDropMoveType.MoveUp : DragAndDropMoveType.MoveDown);
                            $(row).remove();
                        }
                    },
                    dragHandle: "drag-handle"
                });

                Controls.multiform.initializeMultiformBehavior(table, moveRowUp, moveRowDown);
                ko.utils.registerEventHandler(element, "change", () => {
                    updateTableBehaviors();
                });
            },
            sortableTableAfterRender: (elements) => {
                var table = $(elements).closest("table").first();
                table.tableDnDUpdate();
                Controls.multiform.refreshMultiformBehavior(table, true);
            }
        };

        ko.bindingHandlers.textOrDefault = {
            init: (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) => {
                ko.bindingHandlers.text.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
            },
            update: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
                var value = ko.unwrap(valueAccessor());
                var defaultVal = allBindings.get("default") || "";

                if (typeof (value) === "undefined" || value === "" || value === null) {
                    ko.utils.setTextContent(element, defaultVal);
                    return;
                }

                ko.bindingHandlers.text.update(element, valueAccessor, allBindings, viewModel, bindingContext);
            }
        };



        ko.bindingHandlers.dateDisplay = {
            update: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
                var value = ko.unwrap(valueAccessor());
                var isUtc = allBindings.get("isUtc");
                if (isUtc) {
                    if (String(isUtc).toLowerCase() === "true") {
                        isUtc = true;
                    } else if (String(isUtc).toLowerCase() === "false") {
                        isUtc = false;
                    } else if (isUtc !== true || isUtc !== false) {
                        isUtc = false;
                    }
                }
                var m = Service.parseMoment(value, isUtc);
                if (m && m.isValid()) {
                    var dateTimeFormat = allBindings.get("format") || "";

                    m.local();
                    var val = Service.formatDateToString(m, dateTimeFormat);
                    var output = `<span title="${m.utc().toISOString()}">${val}</span>`;
                    ko.utils.setHtml(element, output);
                    return;
                }


                ko.bindingHandlers.text.update(element, valueAccessor, allBindings, viewModel, bindingContext);
            }

        }

        ko.bindingHandlers.usernameDisplay = {
            update: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
                ko.bindingHandlers.text.update(element, valueAccessor, allBindings, viewModel, bindingContext);
                var value = ko.unwrap(valueAccessor());

                var svc = new usernameLookup.Service();
                svc.lookupUsername(value).then((r) => {
                    if (r) {
                        var val = `<span title="${r.UserPrincipalName}">${r.DisplayName}`;
                        if (r.Email) {
                            val += ` (<a href="mailto:${r.Email}">${r.Email}</a>)`;
                        }
                        val += "</span>";
                        ko.utils.setHtml(element, val);
                    }
                }, error => { ko.bindingHandlers.text.update(element, valueAccessor, allBindings, viewModel, bindingContext); });



                //ko.bindingHandlers.text.update(element, valueAccessor);
            }

        }

        ko.bindingHandlers.busyIndicator = {
            init: (element, valueAccessor) => {
            },
            update: (element, valueAccessor, allBindings) => {
                var value = ko.unwrap(valueAccessor());
                if (value) {
                    Controls.setBusy(element);
                } else {
                    Controls.clearBusy(element);
                }
            }
        };

        function isScrolledIntoView(elem: HTMLElement) {
            var $elem = $(elem);
            var doc = elem.ownerDocument;
            var win = doc.defaultView || doc.parentElement;
            var $window = $(win);

            var docViewTop = $window.scrollTop();
            var docViewBottom = docViewTop + $window.height();

            var elemTop = $elem.offset().top;
            var elemBottom = elemTop + $elem.height();

            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }
        ko.bindingHandlers.scrollTo = {
            update: (element, valueAccessor) => {



                var value = ko.utils.unwrapObservable(valueAccessor());
                if (value) {
                    var el = $(element);
                    if (el.length) {
                        if (!isScrolledIntoView(el[0])) {
                            el[0].scrollIntoView();
                        }
                    }
                }
            }
        };

        let clipboardSupported = false;
        let clipboardInitialized = false;

        let initClipboard = () => {
            if (!clipboardInitialized) {
                if (ClipboardJS.isSupported()) {
                    clipboardSupported = true;
                    let clipboard = new ClipboardJS("button[data-btn-clip='true']");
                    clipboard.on("success", e => { $(e.trigger).attr("data-original-title", "Copied").tooltip("show") });

                } else {
                    clipboardSupported = false;
                }
                clipboardInitialized = true;
            }
        };


        ko.bindingHandlers.clipboardText = {

            init: (element, valueAccessor, allBindingsAccessor) => {
                // ensure the clipboard jquery handler is initialized
                initClipboard();
                var $el = $(element);

                if (!clipboardSupported) {
                    // don't add any button stuff if the clipboard isn't supported.
                    return;
                }
                var value = ko.utils.unwrapObservable(valueAccessor());
                $el.append(`<span>${value}</span>`);
                let $clipButton = $el.append(`<button type='button' data-clipboard-text='${value}' data-original-title="" data-btn-clip="true"><span class="sr-only">Copy to clipboard</span><i class="fa fa-clipboard" aria-hidden="true"></i> </button>`);


                //handle disposal (if KO removes by the template binding)
                ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                    $clipButton.remove();
                });
            },
            update: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
                var $el = $(element);
                if (!clipboardSupported) {
                    ko.bindingHandlers.text.update(element, valueAccessor, allBindings, viewModel, bindingContext)
                    // don't add any button stuff if the clipboard isn't supported.
                    return;
                }
                var value = ko.utils.unwrapObservable(valueAccessor());
                let $span = $el.find("span");
                $span.val(value);
                $span.siblings("button").attr("data-clipboard-text", value);
            }

        }

        let manageMenuFocusOnKeyDown = (ev) => {
            //TODO:  Bootstrap handles the basic up and down but not wrapping.  Figure out how to override their focus that prevents wrapping around with up and down arrow.
            //console.log("Keydown event...");
            //console.log(ev);
            //let menuContainer = $(ev.target).closest("[role='menu']");
            let menuContainer = $(ev.currentTarget); //container with controls
            //let menuItems = menuContainer.find("[role='menuitem']").find("button,a");
            let menuItems = menuContainer.find("[role='menuitem']");
            $.merge(menuItems, menuContainer.find("[role='menuitem']").find("button,a")); //look for possible focusable controls inside the menuitem

            //on keydown  up and down arrows change focus and wrap.  Home/end & pageup/pagedown to first and last items
            let key = ev.originalEvent.key;
            switch (key) {
                case 'Up':
                case 'ArrowUp':
                    if (ev.target != menuItems.first()[0]) { //previous item.  bootstrap is handling focus
                        ev.target.tabIndex = -1; //the event we are on will lose focus so change tabIndex.  target is the button that has the key event
                        let itemIndex = menuItems.index(ev.target);
                        menuItems[itemIndex - 1].tabIndex = 0;
                    } else { //TODO: wrap from first to last item
                        ev.target.tabIndex = 0; //since bootstrap won't wrap leave the current item focusable
                        //menuItems.last()[0].tabIndex = 0;
                        //menuItems.last().focus();
                    }
                    break;
                case 'Down':
                case 'ArrowDown':
                    if (ev.target != menuItems.last()[0]) { //next item.  bootsrap is handling focus
                        ev.target.tabIndex = -1; //the event we are on will lose focus so change tabIndex.  target is the button that has the key event
                        let itemIndex = menuItems.index(ev.target);
                        menuItems[itemIndex + 1].tabIndex = 0;
                    } else { //TODO: wrap from last to first item
                        ev.target.tabIndex = 0; //since bootstrap won't wrap leave the current item focusable
                        //menuItems.first()[0].tabIndex = 0;
                        //menuItems.first()[0].focus();
                    }
                    break;
                case 'Home':
                case 'PageUp':
                    ev.preventDefault(); //don't scroll the view port, just move focus in menu
                    ev.target.tabIndex = -1; //the event we are on will lose focus so change tabIndex.  target is the button that has the key event
                    //go to first item
                    menuItems.first()[0].tabIndex = 0;
                    menuItems.first().focus();
                    break;
                case 'End':
                case 'PageDown':
                    ev.preventDefault(); //don't scroll the view port, just move focus in menu
                    ev.target.tabIndex = -1; //the event we are on will lose focus so change tabIndex.  target is the button that has the key event
                    //go to last item
                    menuItems.last()[0].tabIndex = 0;
                    menuItems.last().focus();
                    break;
                case 'Tab':
                    //got to next tab stop and close the dropdown
                    let dd = $(ev.target).closest(".dropdown");
                    if (dd.hasClass("show")) {
                        dd.dropdown("toggle");
                    }
                    break;
            }
        }

        ko.bindingHandlers.setMenuFocus = {
            init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
                let btn = $(element);
                if (ko.unwrap(valueAccessor())) {
                    if (btn.attr("aria-controls") && btn.closest(".dropdown")) {
                        btn.closest(".dropdown").off("shown.bs.dropdown").on("shown.bs.dropdown", (e) => {
                            //console.log("shown.bs.dropdown...");
                            //console.log(e);
                            let ddBtn = $(e.relatedTarget);
                            if (ddBtn.attr("aria-controls")) {
                                let ddMenu = $("#" + ddBtn.attr("aria-controls"));
                                //ddMenu.off("keydown").on("keydown", (ev) => {
                                //    manageMenuFocusOnKeyDown(ev);
                                //});

                                let ddMenuItems = ddMenu.find("[role='menuitem']:visible");
                                $.merge(ddMenuItems, ddMenu.find("[role='menuitem']:visible").find("button:visible,a:visible")); //look for possible focusable controls inside the menuitem
                                //console.log("Menu items...");
                                //console.log(ddMenuItems);
                                ddMenuItems.each((index, elem) => {
                                    if (index === 0) {
                                        elem.tabIndex = 0;
                                        elem.focus();
                                    }
                                    else {
                                        elem.tabIndex = -1;
                                    }
                                    //    $(elem).off("keydown.menu");
                                    //    $(elem).on("keydown.menu", (ev) => {
                                    //        manageMenuFocusOnKeyDown(ev);
                                    //    });
                                });
                            }
                        }).off("keydown.menu").on("keydown.menu", (ev) => {
                            //console.log("keydown event on the .dropdown");
                            manageMenuFocusOnKeyDown(ev);
                        });
                    }
                }
                // This will be called when the binding is first applied to an element
                // Set up any initial state, event handlers, etc. here
            },
            update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
                // This will be called once when the binding is first applied to an element,
                // and again whenever any observables/computeds that are accessed change
                // Update the DOM element based on the supplied values here.
            }
        }
            
    }
}
